
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import {
    Action,
  } from 'vuex-class';

  @Component
  export default class DlgAdvisorDelete extends Vue {
    @Prop({type: Object, default: null}) private advisor!: object;

    @Action('admin/advisors/remove') private advisorDel!: any;
    @Action('admin/advisors/read') private read!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      const res = await this.advisorDel(this.advisor);
      if (res) {
        this.read();
        this.dialog = false;
      }
      this.loading = false;
    }
  }
